import React, {useEffect, useState, createRef} from 'react';
import styled from 'styled-components'
import Player from "@vimeo/player";
import useResponsive from "../../hooks/responsive";
import {trackGaussEvent} from "../../helper/analytics";

export default function PrivateclassVideo({video, hasVideo, slug}) {

    const playerDiv = createRef()
    const [player, setPlayer] = useState(null)
    const [isMobile, maxContainerWidth] = useResponsive()

    useEffect(() => {
        if(!playerDiv.current) return


        setPlayer(new Player(playerDiv.current, {
            id:441654238,
            width: isMobile ?  280: 640,
        }))

    }, [playerDiv])

    useEffect(() => {
        if(!player || (!video || video.length === 0)) return

        player.loadVideo(parseInt(video))

    }, [player, video])

    useEffect(() => {
        if(!player) return

        const listener = (video) => {

            // scrolltotop
            //should we play by default?
            // player.play()

        }

        player.on('loaded', listener)

        let alreadySentPlayEvent = false
        const onplaylistener = (event) => {
            if(alreadySentPlayEvent) return

            alreadySentPlayEvent = true;

            trackGaussEvent('play_video_privateclass', {
                video,
                slug
            })
        }

        player.on('play', onplaylistener)

        return () => {
            player.off('loaded', listener)

        }
    }, [player])

    if(!hasVideo) return null;

    return (
        <Container>
            <Title>Vídeo de la clase</Title>
            {(video && video.length > 0) && (
                <VideoContainer>
                    <div ref={playerDiv}></div>
                </VideoContainer>
            )}
            {video && video.length > 0
                ? null
                : (<NoAccess>Parece que no tienes acceso. <a href='/buy/page'>Suscríbete</a> para acceder al contenido</NoAccess>)
            }
        </Container>

    )
}


const Title = styled.div`
    font-size: 22px;
    padding-top: 24px;
    padding-bottom: 24px;
    font-weight: bold;
    color: #FA9F63;
    text-align: center;
`

const NoAccess = styled.div`
    font-size: 18px;
    text-align: center;
    padding-top: 24px;
`
const VideoContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center
`

const Container = styled.div`
    padding: 24px;
    margin-left: 12px;
    padding-top: 48px;

`
